export const getBrowserLanguage = () => (navigator.language.includes('pl') ? 'pl' : 'en');
